module.exports = __webpack_public_path__ + "images/questions/qa_asset_value_a3f3a4e0d3b84bbfea537e08389a3234.png";